import ChecklistComponent, {
  ChecklistItemComponentProps,
} from './ChecklistItemComponent';

export default ChecklistComponent;

export type { ChecklistItemComponentProps };
